import { AxiosResponse } from 'axios';

import RestAPI from '../../../components/Common/restApi';

import { BillingPlanFeatureType } from './constants';

export type Feature = {
  enabled: boolean;
  quantity: number;
  name: BillingPlanFeatureType;
};

export type Response = {
  can_see_multitech_view: boolean;
  data: Feature[];
};

/**
 * @deprecated  To fetch an org's enabled features, use the `useBillingEnabledFeatures` hook instead.
 */
export const FeaturesApi = {
  index() {
    return RestAPI.get('/alpha/organization/features') as Promise<AxiosResponse<Response>>;
  },
};
